import { Button, Form, Input, Modal, Select } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { layoutCategoryModalSliceDispatch, pickAFileSliceDispatch } from "../../Constants/ReduxConstants";
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";

function LayoutCategoryModal({ caption, layout }) {
    const currentQuestions = useSelector((state: any) => state.pickAFile.questions);
    const currentLayout = useSelector((state: any) => state.pickAFile.layout);

    const open = useSelector((state: any) => state.layoutCategoryModal.open);
    const layoutToAdd = useSelector((state: any) => state.layoutCategoryModal.layoutToAdd);

    const dispatch = useDispatch()

    const { CreateContentsFromStates } = ReduxHelpers();

    let questionDropDownList = currentQuestions.map(b => { return ({ key: b.dataKey, text: b.dataKey, value: b.dataKey }) })

    let layoutValuesToShow = layout

    let adder = AddLayout;
    let buttonCaption = caption;

    function AddLayout(oldList, newLayout) {
        let listToUse;
        if (oldList) {
            listToUse = oldList;
        } else {
            listToUse = currentLayout
        }

        listToUse.push(newLayout)

        dispatch({ type: pickAFileSliceDispatch.setLayout, payload: listToUse })

        CreateContentsFromStates({ layout: listToUse });
    }

    const onSubmit = () => {
        //We are adding a new one
        if (adder) {
            adder(null, layoutToAdd)
        }

        dispatch({ type: layoutCategoryModalSliceDispatch.setOpen, payload: false });
    }

    const onCancel = () => {
        dispatch({ type: layoutCategoryModalSliceDispatch.setOpen, payload: false });
    }

    const onChange = (event) => {
        //NOTE: Change actionIds to integers
        let valueToUse = event.target.value;

        dispatch({ type: layoutCategoryModalSliceDispatch.setLayoutToAdd, payload: { ...layoutToAdd, [event.target.id]: valueToUse } });
    }

    const onQuestionsDropDownChange = (value) => {
        dispatch({ type: layoutCategoryModalSliceDispatch.setLayoutToAdd, payload: { ...layoutToAdd, ['fields']: value } });
    }


    return open ? (
        <Modal
            title="Layout Details"
            footer={null}
            closable={false}
            open={open}
            destroyOnHidden={true}
            onCancel={onCancel}
        >
            <Form
                onFinish={onSubmit}
                preserve={false}
            >
                <Form.Item rules={[{ required: true }]} name="Category Name" label="Category Name">
                    <Input id="name" placeholder='Category Name' defaultValue={layoutValuesToShow?.name} onChange={onChange} required pattern=".*\S+.*" title="This field is required" />
                </Form.Item>
                <Form.Item rules={[{ required: true }]} name="Questions" label="Questions">
                    <Select
                        placeholder='Select Questions'
                        mode="multiple"
                        options={questionDropDownList}
                        defaultValue={layoutValuesToShow?.fields}
                        onChange={onQuestionsDropDownChange}
                    />
                </Form.Item>
                <div style={{ display: 'flex', justifyContent: 'end', paddingTop: '1em' }}>
                    <Form.Item>
                        <Button onClick={onCancel}>
                            Cancel
                        </Button>
                    </Form.Item>
                    <Form.Item>
                        <Button htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    ) : (
        <Button onClick={() => {
            dispatch({ type: layoutCategoryModalSliceDispatch.setOpen, payload: true });
            dispatch({ type: layoutCategoryModalSliceDispatch.setLayoutToAdd, payload: layout });
        }}>{buttonCaption}</Button>
    )
}

export default LayoutCategoryModal;